import { QueryKey } from 'constants/reactQuery';

export const recentlyReadQueryKey = {
  recentlyReads: [QueryKey.RecentlyRead] as const,
  recentlyRead: (contentId: number) => [...recentlyReadQueryKey.recentlyReads, contentId] as const,
};
